// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"955ceb12","763":"1c38ed11","959":"9084174c"}[chunkId] + ".js";
};